<template>
  <div class="d-flex align-items-center min-vh-100">
    <b-container>
      <b-row class="justify-content-center">
        <h1 class="float-left display-3 mr-4">403</h1>
        <div>
          <h4 class="pt-3">{{$t('page_unauthorized_view.title')}}</h4>
          <p class="text-muted">
            {{$t('page_unauthorized_view.content')}}
          </p>
        </div>
        <b-button class="mt-4" block variant="primary" @click="logout">
          {{$t('page_unauthorized_view.logout')}}
        </b-button>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ActionTypes } from '@/store/action-types'

export default {
  name: 'Unauthorized',
  created() {
    window.document.title = 'Unauthorized'
  },
  methods: {
    logout() {
      this.$store.dispatch(ActionTypes.AUTH_LOGOUT)
    }
  }
}
</script>
